<template>
    <div class="content-wrapper">

        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.setting.editCampus')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <back-button></back-button>
                
                <b-alert v-model="disableEditForm" variant="info">{{disableEditFormMessage}}</b-alert>

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <form role="form" @submit.prevent="submit()">
                    <div class="card">
                        <div class="card-header bg-light">
                            <div class="card-title">{{$t('form.setting.editCampus')}}</div>
                            <b-button type="submit" variant="primary" class="float-right"
                                :disabled="disableEditForm || !permissions.editSettingsCampuses">{{$t('button.save')}}
                            </b-button>
                        </div>

                        <div class="card-body">
                            <div class="form-group">
                                <label>{{$t('form.setting.partnerCampusLocation')}}<span
                                        class="text-danger">*</span></label>
                                <input type="text" class="form-control" v-model="campus.PartnerCampusLocation" required>
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.partnerCode')}}<span class="text-danger">*</span></label>
                                <v-select label="PartnerCode" :options="partners" v-model="campus.PartnerID"
                                    :reduce="partners => partners.PartnerID">
                                </v-select>
                            </div>

                            <div class="form-group">
                                <label>
                                    <input type="checkbox" v-model="campus.PartnerCampusActive">
                                    {{$t('form.setting.active')}}
                                </label>
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.sortOrder')}}</label>
                                <input type="number" class="form-control" v-model="campus.PartnerCampusSortOrder">
                            </div>
                        </div>
                    </div>
                </form>

            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['permissions', 'editFormInterval'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                interval: '',
                disableEditFormMessage: '',
                disableEditForm: false,
                closing: true,

                campus: {
                    PartnerCampusLocation: '',
                    PartnerID: null,
                    PartnerCampusActive: null,
                    PartnerCampusSortOrder: null,
                },

                partners: []
            }
        },

        mounted() {
            if (!this.permissions.viewSettingsCampuses) {
                return this.$router.push('/');
            }

            if (this.permissions.editSettingsCampuses) {
                this.checkForEdit();
                this.interval = setInterval(() => this.checkForEdit(), this.editFormInterval);
            }

            this.getPartners();
            this.fetch();
        },

        watch: {
            campus: {
                handler(val) {
                    this.closing = false;
                },
                deep: true
            }
        },

        methods: {

            checkForEdit() {
                axios
                    .get("/api/check-for-edit/" + this.$route.params.id + "/campus")
                    .then(response => {
                        if (response.data.warning == 0) {
                            this.fetch();
                            this.disableEditForm = false;
                        }

                        if (response.data.warning == 1) {
                            clearInterval(this.interval);
                            this.disableEditFormMessage = response.data.message;
                            this.disableEditForm = true;
                        }

                        if (response.data.warning == 2) {
                            this.disableEditFormMessage = response.data.message;
                            this.disableEditForm = true;
                        }
                    })
                    .catch(error => {
                        // console.log(error.response);
                    })
            },

            fetch() {
                this.isLoading = true;

                axios
                    .get(`/api/campuses/${this.$route.params.id}/edit`)
                    .then(response => {

                        if (response.data.success) {
                            this.campus = response.data.data;
                        }

                        setTimeout(() => {
                            this.isLoading = false;
                            this.closing = true;
                        }, 1000);
                    })
                    .catch(error => {
                        console.log('error fetching campus record');
                        this.isLoading = false;
                    });
            },

            getPartners() {
                axios
                    .get('/api/partners?full')
                    .then(response => this.partners = response.data)
                    .catch(error => console.log('error fetching partners'));
            },

            submit() {

                if (this.disableEditForm) return;

                if (this.campus.PartnerCampusLocation == '' || this.campus.PartnerID == null) {
                    return this.showAlert(this.$t('form.validation.error'), 'danger');
                }

                this.clearAlert();

                this.isLoading = true;

                axios
                    .put(`/api/campuses/${this.$route.params.id}`, this.campus)
                    .then(response => {

                        this.isLoading = false;
                        this.closing = true;

                        if (response.data.success) {
                            this.showAlert(response.data.message);

                            setTimeout(() => {
                                this.$router.push({
                                    name: 'CampusIndex'
                                });
                            }, 2000);
                        }

                    }).catch(error => {
                        this.isLoading = false;
                        this.showAlert(error.response.data.message, 'danger');
                    })
            },

            showAlert(message, cls = 'success') {
                this.alertMessage = message;
                this.alertClass = cls;
                this.alert = true;
            },

            clearAlert() {
                this.alert = false;
                this.alertClass = '';
                this.alertMessage = '';
            }
        },

        beforeRouteLeave(to, from, next) {
            if (this.closing) next()
            else {
                const answer = window.confirm(this.$t('leavePrompt'))

                if (answer) {
                    next()
                } else {
                    next(false)
                }
            }
        }
    }

</script>
